// components/QuickViewModal.js
import React, { useState, useEffect,useRef  } from 'react'
import '../../../components/layout/QuickViewModal.css';
const QuickViewModal = ({ productId, onClose }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Ativa a animação após montagem
    const timer = setTimeout(() => setShow(true), 10);
    return () => clearTimeout(timer);
  }, []);

  const [product, setProduct] = useState(null);

    useEffect(() => {
    if (!productId) return;

    const fetchProductDetails = async () => {
      try {
        const response = await fetch(`https://advancelighting.pt/detalhe_prod.php?id=${productId}`);
        const data = await response.json();
        setProduct(data);
      } catch (err) {
        console.error("Erro ao buscar detalhes do produto:", err);
      }
    };

    fetchProductDetails();
  }, [productId]);

  if (!product) return null;
   return (
    <>
    <div className='quickVewPopup'>
      <div className="quick-view-overlay" onClick={onClose}>
      <div className={`quick-view-box ${show ? 'show' : ''}`} onClick={(e) => e.stopPropagation()}>
       <div className="modal_prod" />
  
        <div className="modal__content">
          <i className="modal__close far fa-times-circle" onClick={onClose} role="button" aria-label="Fechar"/>
          <div className="modal__left">
           <img src={product.imgP} alt={product.nome} />
          </div>
          <div className="modal__right">
            <div className="detail">
              <h2 className="detail__title">{product.nome}</h2>
              <div className='logo-brand'>
               <img src={product.logo} alt={product.nome} />
              </div>

              <p className="price">
                <span className="price-amount">
                  <bdi className='pvp_value'>{product.pvp}€</bdi>
                </span>&nbsp; <small className="price-suffix"> <span> *Acresce IVA à taxa legal em vigor</span></small>
              </p>

              <hr className="card-line w-100"></hr>
              <div className='details_prod'>
              <p className="detail__description">{product.descri} </p>
              <p className='item'><b>IP:</b> {product.ip}</p>
              {product?.volt != null &&<p className='item'><b>Tensão:</b> {product.volt}V</p>}
              {product?.cri != null &&<p className='item'><b>CRI:</b> {product.cri}</p>}
              <p className='item'><b>Referências:</b> {product.referencias.join(', ')}</p>
              </div>
            </div>

            <span className='share_prod'>
                <span className="wd-label share-title">Share:</span>
                <a rel="noopener noreferrer nofollow" href="" target="_blank"className=" wd-social-icon fab fa-facebook-square"aria-label="Facebook social link" >
                  <span className="wd-icon" />
                </a>
                <a rel="noopener noreferrer nofollow" href="https://www.instagram.com/advancelightpt/"target="_blank"className=" wd-social-icon fab fa-instagram"aria-label="Instagram social link" >
                  <span className="wd-icon" />
                </a>
                <a rel="noopener noreferrer nofollow" href="https://www.youtube.com/channel/UCWZeoH9q8Rg4KFIWHDzQVRw" target="_blank" className=" wd-social-icon fab fa-youtube" aria-label="Youtube social link" >
                  <span className="wd-icon" />
                </a>
                <a rel="noopener noreferrer nofollow" href="https://www.linkedin.com/company/grupo-ruan-ruan/" target="_blank" className="fab fa-linkedin wd-social-icon"aria-label="Linkedin social link" >
                  <span className="wd-icon" />
                </a>
                <a rel="noopener noreferrer nofollow" href="https://www.tiktok.com/@advancelightpt" target="_blank" className="wd-social-icon fab fa-tiktok" aria-label="Tik Tik social link" >
                  <span className="wd-icon" />
                </a>
            </span>
          </div>
        </div>
      </div>
    </div>
    </div>
    </>
  );
};

export default QuickViewModal;